import { Award, ShieldCheck, Factory, Sparkles, Cog, Gauge, IndianRupee, Truck, Headphones, Building2 } from "lucide-react";

const FEATURES = [
  { icon: Award, title: "Established in 2014", desc: "Over a decade of dedicated manufacturing experience." },
  { icon: ShieldCheck, title: "BIS Certified Products", desc: "Products carry Bureau of Indian Standards certification." },
  { icon: Factory, title: "ISO Certified Facility", desc: "Manufacturing facility operates to ISO quality systems." },
  { icon: Sparkles, title: "Premium Raw Materials", desc: "Electrolytic copper, EC-grade aluminium & premium rubber compounds." },
  { icon: Cog, title: "Modern Infrastructure", desc: "Advanced machinery ensuring precision at every stage." },
  { icon: Gauge, title: "Strict Quality Assurance", desc: "Rigorous batch-wise testing across production lines." },
  { icon: IndianRupee, title: "Competitive Pricing", desc: "Direct-from-manufacturer pricing without compromise." },
  { icon: Truck, title: "On-Time Delivery", desc: "Reliable logistics with PAN-India distribution network." },
  { icon: Headphones, title: "Dedicated Support", desc: "Responsive customer service before, during and after sale." },
  { icon: Building2, title: "Government & Private Trust", desc: "Trusted supplier across Government and Private sectors." },
];

export const WhyChooseUs = () => {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="relative bg-[#0E1116] py-24 md:py-32 border-t border-[#F5F1EA]/8"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-brand-red" />
              <span data-testid="why-us-eyebrow" className="text-[11px] uppercase tracking-[0.35em] text-brand-red font-medium font-sans">
                Why Choose Niryasa
              </span>
            </div>
            <h2
              data-testid="why-us-heading"
              className="font-display tracking-tight text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] font-medium"
            >
              Engineering <span className="italic text-brand-red font-normal">Quality.</span> <br />
              Delivering <span className="italic text-brand-red font-normal">Trust.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base text-[#A8A29A] leading-relaxed font-sans">
              At Niryasa Industries, quality is not just a standard — it is our promise. Every product is engineered to deliver exceptional reliability, long service life, and consistent performance.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#F5F1EA]/8">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={i}
                data-testid={`feature-card-${i}`}
                className="group relative bg-[#0E1116] hover:bg-[#161A21] transition-colors p-6 flex flex-col gap-4 min-h-[200px]"
              >
                <div className="flex items-center justify-between">
                  <Icon size={22} className="text-brand-red" strokeWidth={1.5} />
                  <span className="text-[10px] uppercase tracking-[0.25em] text-white/30 font-sans">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div>
                  <h3 className="font-display tracking-tight text-white text-lg leading-tight mb-2 font-medium">
                    {f.title}
                  </h3>
                  <p className="text-xs text-white/55 leading-relaxed font-sans">
                    {f.desc}
                  </p>
                </div>
                <div className="absolute bottom-0 left-0 h-0.5 w-0 bg-brand-red group-hover:w-full transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
